import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CasoUsoDto } from '@models/seguridad/casosUso/casoUsoDto.model';
import { UpdateCasosUsoRequest } from '@models/seguridad/casosUso/updateCasosUsoRequest.model';
import { MenuDto } from '@models/seguridad/menu/menuDto.model';
import { CasosUsoService } from '@services/seguridad/casos-uso/casos-uso.service';
import { MenuService } from '@services/seguridad/menu/menu.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { DialogUpdateCasoUsoComponent } from './dialog-update-caso-uso/dialog-update-caso-uso.component';

@Component({
  selector: 'app-actualizar-caso-uso',
  templateUrl: './actualizar-caso-uso.component.html',
  styleUrls: ['./actualizar-caso-uso.component.css']
})
export class ActualizarCasoUsoComponent implements OnInit {

  formBuilder = new FormBuilder;
  form: any;
  menus!: MenuDto[];
  casoUsoDto!:CasoUsoDto;
  get f() { return this.form.controls; }

  constructor(
    public dialogRef: MatDialogRef<DialogUpdateCasoUsoComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private casosUsoService: CasosUsoService,
    private menuService: MenuService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.form = this.formBuilder.group({
      Descripcion: ["", Validators.compose([Validators.required,])],
      Icono: ["", Validators.compose([Validators.required,])],
      Path: ["", Validators.compose([Validators.required])],
      Menu: ["", Validators.compose([Validators.required])],
    })
  }

  ngOnInit(): void {
    this.getAllMenus()
    this.getById(this.data.id)
  }

  getAllMenus() {
    this.spinner.show("spBusquedaMenu")
    this.menuService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaMenu")
          this.menus = data
        },
        error => {
          this.spinner.hide("spBusquedaMenu")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  getById(id:number) {
    this.spinner.show("spModificarCasoUso")
    this.casosUsoService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spModificarCasoUso")
          this.casoUsoDto = data
          this.seteaForm(data)
        },
        error => {
          this.spinner.hide("spModificarCasoUso")
          this.snackBar.showError(error, "Error");
        }
      )
  }


  doAction() {

    let updateCasosUsoRequest: UpdateCasosUsoRequest = new UpdateCasosUsoRequest
    updateCasosUsoRequest.id = this.casoUsoDto.id
    updateCasosUsoRequest.descripcion = this.form.controls["Descripcion"].value
    updateCasosUsoRequest.icon = this.form.controls["Icono"].value
    updateCasosUsoRequest.path = this.form.controls["Path"].value
    updateCasosUsoRequest.id_menu = this.form.controls["Menu"].value
    this.update(updateCasosUsoRequest)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  update(updateCasosUsoRequest: UpdateCasosUsoRequest) {
    this.spinner.show("spModificarCasoUso")
    this.casosUsoService.update(updateCasosUsoRequest)
      .subscribe(
        data => {
          this.spinner.hide("spModificarCasoUso")
          this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar });
        },
        error => {
          this.spinner.hide("spModificarCasoUso")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  seteaForm(casoUsoDto: CasoUsoDto) {
    this.form.controls["Descripcion"].setValue(casoUsoDto.descripcion)
    this.form.controls["Icono"].setValue(casoUsoDto.icon)
    this.form.controls["Path"].setValue(casoUsoDto.path)
    this.form.controls["Menu"].setValue(casoUsoDto.menu.id)
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }

}
